<main class="auth-page compact">
  <section class="auth-card">
    <a class="brand" [routerLink]="loginRoute">
      <img class="brand-logo" src="/brand/logo-horizontal.png" alt="ZepBazaar" />
      <strong>{{ portal === 'admin' ? 'Platform Security' : portal === 'franchise' ? 'Franchise Partner Portal' : 'Business Portal' }}</strong>
    </a>

    <div class="heading">
      <p>Account recovery</p>
      <h1>Forgot your password?</h1>
      <span>Enter your registered email. We’ll send a 6-digit OTP to verify your account.</span>
    </div>

    <form (ngSubmit)="onSubmit()">
      <label>
        <span>Email address</span>
        <input
          type="email"
          name="email"
          [(ngModel)]="email"
          placeholder="{{ portal === 'admin' ? 'admin@zepbazaar.com' : portal === 'franchise' ? 'partner@example.com' : 'owner@business.in' }}"
          autocomplete="email"
          required
        />
      </label>

      @if (successMessage) {
        <p class="state success">{{ successMessage }}</p>
      }

      @if (errorMessage) {
        <p class="state error">{{ errorMessage }}</p>
      }

      <button type="submit" [disabled]="isSubmitting">
        <span class="material-symbols-outlined" aria-hidden="true">mail</span>
        {{ isSubmitting ? 'Sending OTP…' : 'Continue' }}
      </button>
    </form>

    <p class="switch"><a [routerLink]="loginRoute">Back to {{ portal === 'admin' ? 'admin' : portal === 'franchise' ? 'franchise' : 'business' }} sign in</a></p>
  </section>
</main>
